// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modmain
{
    background-color: #000000;
  
    width:100%;
    color: white;
}


.modnavbar
{
    height:50px;
    width:100%;
    /* background-image: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); */
    display: flex;
    justify-content: center;
    align-items: center;
}
#load_btn{
    background-color: #5E39C7;
  color:white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
#load_btn:hover{

  background-color: #7A56E2;
}
#expandall_btn{
    background-color: #5E39C7;
    color:white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}
#expandall_btn:hover{

    background-color: #7A56E2;
  }
#collapse_btn{
    background-color: #5E39C7;
    color:white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}
#collapse_btn:hover{

    background-color: #7A56E2;
  }
  .expand_btn{
    background-color: rgb(83, 83, 247);
    color: white;
    border:none;
    border-radius: 4px;
    cursor: pointer;
  }
  .show_btn{
    background-color: rgb(83, 83, 247);
    color: white;
    border:none;
    border-radius: 4px;
    cursor: pointer;
  }
  .expand_btn:hover{
    background-color: rgb(108, 108, 248);

  }
  .schedule_btn{
    background-color: #642bff;
    border: none;
    color:white;
   
    margin-right: 10px;
  }
  .monitor_btn{
    border:none;
    
  }
  #close_btn{
    background-color: rgb(243, 42, 76);
    color: white;
    border:none;
    border-radius: 4px;
    cursor: pointer;
  }
  #close_btn:hover{
    background-color: rgb(235, 78, 104);
    ;
  }
  .show_btn:hover{
    background-color: rgb(108, 108, 248);

  }
.addflow
{
    margin-top: 30px;
    width:100%;

    display: flex;
    justify-content: center;
}
.addflowbtn
{
    
   
    display: flex;
    outline: none;
    cursor: pointer;
    gap:5px;    
    font-size: 14px;
    line-height: 1;
    border-radius: 500px;
    transition-property: background-color,border-color,color,box-shadow,filter;
    transition-duration: .3s;
    border: 1px solid transparent;
    letter-spacing: 2px;
    min-width: 160px;
    text-transform: uppercase;
    white-space: normal;
    font-weight: 600;
    text-align: center;
    padding: 16px 14px 18px;
    color: #fff;
    background-color: #642bff;
    height: 40px;
    align-items: center;
    justify-content: center ;

}
.addflowbtn:hover{
    border: 2px solid #642bff;
    background: transparent;
    color: rgb(255, 255, 255);
}
.llogo
{
    width:20px;
    height:20px 
}

.prevflows
{
    border: 2px solid rgb(255, 255, 255);
    width: 80%;
    height:400px;
    text-align: center;
    border-radius: 10px;
    margin-top: 10px;
    padding: 10px;
    font-weight:600;
}
.table{
   
    margin: auto;
    margin-top: 36px;
}
.table th{
    background-color: #642bff;
    padding: 4px;
}
.table_inte tr{
    background-color: white;
    color: black;
}

.close-schedule{
    position: absolute;
    top: 190px;
    right: 510px;
    border: none;
    cursor: pointer;
    color: red;
    font-size: 16px;
    color: #555;
}
.close-schedule:hover{
    color:red;
}

.inte-container{
    background-color: black;
    height: 78vh;
    width: 100%;
}
table th {
 width: 160px;
 padding: 2px;
}
td{
    padding: 10px;
}

.modal{
  position: fixed;
  top:0;
  left:0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
}
.table_result{
    border-collapse: collapse;
    height: 40px;
    
}
.table_result th{
    background-color: #ffffff;
    color:black;
}
.table_result tr{
    background-color: white;
    color: black;
}
.close-btn{
    background: transparent;
   cursor: pointer;
    color: red;
    border: none;
}
.heading{
    color: white;
    
}
.side-btns{
    display: flex;
}
.side-btn{
   padding: 10px 20px;
   border-radius:100px;
   cursor: pointer;
   height: 40px;
}

.cross{
    font-size: 30px;
}
.modal-title{
    padding: 2px;
    font-size: 16px;
    margin-bottom: 10px;
    text-align: center;
}
.modal-footer{
    display: flex;
    justify-content: center;
}
.btns{
    width: 300px;
    display: flex;
    justify-content: space-between;
}
.modal-dialog{
  background-color: #642bff;
  width: 452px;
  padding: 10px;
  box-shadow: 2px solid black;
  border-radius: 6px;
}

.modmainview
{
    display: flex;
    flex-direction: column;
    gap:10px;
    justify-content: center;
    align-items: center;
}

.btn{
    padding: 8px 10px;
    margin-top: 10px;
}

.action_btn{
    display: flex;
   width: 600px;
    justify-content: space-between;
}

/* Modal Styling */
.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    display: flex;
    justify-content: center;
    align-items: center;
}
.close-button {
    position: absolute;
    top: 30px;
    right: 220px;
    padding: 5px;
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 1.2rem;
    color: red;
}

.close-button:hover {
    color: #ff0000;
}

.smodal-content {
 
   
    background-color: white;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.modal-content {
    overflow-y: scroll;
    height: 500px;
   
    background-color: white;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}




h1 {
    margin-bottom: 20px;
}



label {
    font-weight: 500;
}

input[type="text"],
select {
    width: 100%;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
}

button {
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

button:hover {
    background-color: #0056b3;
}`, "",{"version":3,"sources":["webpack://./src/components/Mvconnect.css"],"names":[],"mappings":"AAAA;;IAEI,yBAAyB;;IAEzB,UAAU;IACV,YAAY;AAChB;;;AAGA;;IAEI,WAAW;IACX,UAAU;IACV,yEAAyE;IACzE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,yBAAyB;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,yBAAyB;AAC3B;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;AACA;;IAEI,yBAAyB;EAC3B;AACF;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;AACA;;IAEI,yBAAyB;EAC3B;EACA;IACE,kCAAkC;IAClC,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,kCAAkC;IAClC,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,oCAAoC;;EAEtC;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;;IAEX,kBAAkB;EACpB;EACA;IACE,WAAW;;EAEb;EACA;IACE,kCAAkC;IAClC,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,mCAAmC;;EAErC;EACA;IACE,oCAAoC;;EAEtC;AACF;;IAEI,gBAAgB;IAChB,UAAU;;IAEV,aAAa;IACb,uBAAuB;AAC3B;AACA;;;;IAII,aAAa;IACb,aAAa;IACb,eAAe;IACf,OAAO;IACP,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,0EAA0E;IAC1E,wBAAwB;IACxB,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,wBAAwB;;AAE5B;AACA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,yBAAyB;AAC7B;AACA;;IAEI,UAAU;IACV;AACJ;;AAEA;;IAEI,oCAAoC;IACpC,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,eAAe;AACnB;AACA;;IAEI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,UAAU;IACV,eAAe;IACf,WAAW;AACf;AACA;IACI,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;AACf;AACA;CACC,YAAY;CACZ,YAAY;AACb;AACA;IACI,aAAa;AACjB;;AAEA;EACE,eAAe;EACf,KAAK;EACL,MAAM;EACN,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;IACI,yBAAyB;IACzB,YAAY;;AAEhB;AACA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,uBAAuB;IACvB,YAAY;AAChB;AACA;IACI,uBAAuB;GACxB,eAAe;IACd,UAAU;IACV,YAAY;AAChB;AACA;IACI,YAAY;;AAEhB;AACA;IACI,aAAa;AACjB;AACA;GACG,kBAAkB;GAClB,mBAAmB;GACnB,eAAe;GACf,YAAY;AACf;;AAEA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,aAAa;IACb,8BAA8B;AAClC;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;GACd,YAAY;IACX,8BAA8B;AAClC;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC,EAAE,gCAAgC;IACtE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;;;IAGI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,aAAa;;IAEb,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,uCAAuC;AAC3C;;;;;AAKA;IACI,mBAAmB;AACvB;;;;AAIA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".modmain\r\n{\r\n    background-color: #000000;\r\n  \r\n    width:100%;\r\n    color: white;\r\n}\r\n\r\n\r\n.modnavbar\r\n{\r\n    height:50px;\r\n    width:100%;\r\n    /* background-image: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%); */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n#load_btn{\r\n    background-color: #5E39C7;\r\n  color:white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n#load_btn:hover{\r\n\r\n  background-color: #7A56E2;\r\n}\r\n#expandall_btn{\r\n    background-color: #5E39C7;\r\n    color:white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n}\r\n#expandall_btn:hover{\r\n\r\n    background-color: #7A56E2;\r\n  }\r\n#collapse_btn{\r\n    background-color: #5E39C7;\r\n    color:white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n}\r\n#collapse_btn:hover{\r\n\r\n    background-color: #7A56E2;\r\n  }\r\n  .expand_btn{\r\n    background-color: rgb(83, 83, 247);\r\n    color: white;\r\n    border:none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  .show_btn{\r\n    background-color: rgb(83, 83, 247);\r\n    color: white;\r\n    border:none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  .expand_btn:hover{\r\n    background-color: rgb(108, 108, 248);\r\n\r\n  }\r\n  .schedule_btn{\r\n    background-color: #642bff;\r\n    border: none;\r\n    color:white;\r\n   \r\n    margin-right: 10px;\r\n  }\r\n  .monitor_btn{\r\n    border:none;\r\n    \r\n  }\r\n  #close_btn{\r\n    background-color: rgb(243, 42, 76);\r\n    color: white;\r\n    border:none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  #close_btn:hover{\r\n    background-color: rgb(235, 78, 104);\r\n    ;\r\n  }\r\n  .show_btn:hover{\r\n    background-color: rgb(108, 108, 248);\r\n\r\n  }\r\n.addflow\r\n{\r\n    margin-top: 30px;\r\n    width:100%;\r\n\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.addflowbtn\r\n{\r\n    \r\n   \r\n    display: flex;\r\n    outline: none;\r\n    cursor: pointer;\r\n    gap:5px;    \r\n    font-size: 14px;\r\n    line-height: 1;\r\n    border-radius: 500px;\r\n    transition-property: background-color,border-color,color,box-shadow,filter;\r\n    transition-duration: .3s;\r\n    border: 1px solid transparent;\r\n    letter-spacing: 2px;\r\n    min-width: 160px;\r\n    text-transform: uppercase;\r\n    white-space: normal;\r\n    font-weight: 600;\r\n    text-align: center;\r\n    padding: 16px 14px 18px;\r\n    color: #fff;\r\n    background-color: #642bff;\r\n    height: 40px;\r\n    align-items: center;\r\n    justify-content: center ;\r\n\r\n}\r\n.addflowbtn:hover{\r\n    border: 2px solid #642bff;\r\n    background: transparent;\r\n    color: rgb(255, 255, 255);\r\n}\r\n.llogo\r\n{\r\n    width:20px;\r\n    height:20px \r\n}\r\n\r\n.prevflows\r\n{\r\n    border: 2px solid rgb(255, 255, 255);\r\n    width: 80%;\r\n    height:400px;\r\n    text-align: center;\r\n    border-radius: 10px;\r\n    margin-top: 10px;\r\n    padding: 10px;\r\n    font-weight:600;\r\n}\r\n.table{\r\n   \r\n    margin: auto;\r\n    margin-top: 36px;\r\n}\r\n.table th{\r\n    background-color: #642bff;\r\n    padding: 4px;\r\n}\r\n.table_inte tr{\r\n    background-color: white;\r\n    color: black;\r\n}\r\n\r\n.close-schedule{\r\n    position: absolute;\r\n    top: 190px;\r\n    right: 510px;\r\n    border: none;\r\n    cursor: pointer;\r\n    color: red;\r\n    font-size: 16px;\r\n    color: #555;\r\n}\r\n.close-schedule:hover{\r\n    color:red;\r\n}\r\n\r\n.inte-container{\r\n    background-color: black;\r\n    height: 78vh;\r\n    width: 100%;\r\n}\r\ntable th {\r\n width: 160px;\r\n padding: 2px;\r\n}\r\ntd{\r\n    padding: 10px;\r\n}\r\n\r\n.modal{\r\n  position: fixed;\r\n  top:0;\r\n  left:0;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background: rgba(0, 0, 0, 0.5);\r\n}\r\n.table_result{\r\n    border-collapse: collapse;\r\n    height: 40px;\r\n    \r\n}\r\n.table_result th{\r\n    background-color: #ffffff;\r\n    color:black;\r\n}\r\n.table_result tr{\r\n    background-color: white;\r\n    color: black;\r\n}\r\n.close-btn{\r\n    background: transparent;\r\n   cursor: pointer;\r\n    color: red;\r\n    border: none;\r\n}\r\n.heading{\r\n    color: white;\r\n    \r\n}\r\n.side-btns{\r\n    display: flex;\r\n}\r\n.side-btn{\r\n   padding: 10px 20px;\r\n   border-radius:100px;\r\n   cursor: pointer;\r\n   height: 40px;\r\n}\r\n\r\n.cross{\r\n    font-size: 30px;\r\n}\r\n.modal-title{\r\n    padding: 2px;\r\n    font-size: 16px;\r\n    margin-bottom: 10px;\r\n    text-align: center;\r\n}\r\n.modal-footer{\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.btns{\r\n    width: 300px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n.modal-dialog{\r\n  background-color: #642bff;\r\n  width: 452px;\r\n  padding: 10px;\r\n  box-shadow: 2px solid black;\r\n  border-radius: 6px;\r\n}\r\n\r\n.modmainview\r\n{\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap:10px;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.btn{\r\n    padding: 8px 10px;\r\n    margin-top: 10px;\r\n}\r\n\r\n.action_btn{\r\n    display: flex;\r\n   width: 600px;\r\n    justify-content: space-between;\r\n}\r\n\r\n/* Modal Styling */\r\n.modal {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.close-button {\r\n    position: absolute;\r\n    top: 30px;\r\n    right: 220px;\r\n    padding: 5px;\r\n    background-color: transparent;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: 1.2rem;\r\n    color: red;\r\n}\r\n\r\n.close-button:hover {\r\n    color: #ff0000;\r\n}\r\n\r\n.smodal-content {\r\n \r\n   \r\n    background-color: white;\r\n    padding: 20px;\r\n    border-radius: 5px;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.modal-content {\r\n    overflow-y: scroll;\r\n    height: 500px;\r\n   \r\n    background-color: white;\r\n    padding: 20px;\r\n    border-radius: 5px;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n\r\n\r\n\r\nh1 {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n\r\n\r\nlabel {\r\n    font-weight: 500;\r\n}\r\n\r\ninput[type=\"text\"],\r\nselect {\r\n    width: 100%;\r\n    padding: 8px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n}\r\n\r\nbutton {\r\n    padding: 10px 20px;\r\n    background-color: #007bff;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n}\r\n\r\nbutton:hover {\r\n    background-color: #0056b3;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
